// @ts-check
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ArrowLink from "../ArrowLink/arrow-link";
import CustomPrimaryCtaButton from "../CustomPrimaryCtaButton/custom-primary-cta-button";
import Title from "../Title/title";

const TitleIntroRichCtaSection = props => {
    const baseClass = "title-intro-rich-cta-section";
    const rootClasses = classNames(baseClass, {
        [`${props.ContentTextColorClass}--text`]: props.ContentTextColorClass,
        [`content--text-align-${props.AlignContent}`]: props.AlignContent
    });

    return (
        <div className={rootClasses}>
            {props.Title && <Title {...props} />}

            {props.IntroParagraph && (
                <div
                    className={`${baseClass}__intro-paragraph content--intro-paragraph`}
                    dangerouslySetInnerHTML={{ __html: props.IntroParagraph }}
                />
            )}

            {props.RichText && (
                <div
                    className={`${baseClass}__rich-text content-rich-text`}
                    dangerouslySetInnerHTML={{ __html: props.RichText }}
                />
            )}
            {props.CtaLink && (
                <div className={`${baseClass}__action-wrapper`}>
                    {props.ShowCtaAsLink ? <ArrowLink {...props} /> : <CustomPrimaryCtaButton {...props} />}
                </div>
            )}
        </div>
    );
};

TitleIntroRichCtaSection.propTypes = {
    Title: PropTypes.string,
    IsTitleH1: PropTypes.bool,
    IsTitleH3: PropTypes.bool,
    IntroParagraph: PropTypes.string,
    RichText: PropTypes.string,
    CtaLink: PropTypes.string,
    CtaTextColorClass: PropTypes.string,
    CtaBackgroundColorClass: PropTypes.string,
    AlignContent: PropTypes.oneOf(["left", "right", "center"]),
    ContentTextColorClass: PropTypes.string,
    ShowCtaAsLink: PropTypes.bool
};

export default TitleIntroRichCtaSection;
